export default "__VITE_ASSET__nqfN__pE__"